// extracted by mini-css-extract-plugin
export default {"buttonGroup":"buttonGroup-PwEz5","choice":"choice-GeiRi","active":"active-JJF_c","disabled":"disabled-X1nEL"};